// extracted by mini-css-extract-plugin
export var modal = "_uh-0";
export var table = "_uh-1";